module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm3",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.row,
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "check-header"
  }, [_c('div', {
    staticClass: "business-shop-info"
  }, [_c('div', {
    staticClass: "business-shop-box"
  }, [_c('div', {
    staticClass: "shop-name"
  }, [_c('div', {
    staticStyle: {
      "font-size": "19px"
    }
  }, [_vm._v("七彩星级考级报名")])])]), _vm._v(" "), _c('div', {
    staticClass: "shop-address"
  }, [_vm._v("请确认考级信息，选择考级人员提交报名")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }), _vm._v(" "), _c('el-divider', [_vm._v("考级信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "时间地点"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.row.province) + _vm._s(_vm.row.city) + "(" + _vm._s(_vm.row.datetitle) + ")\n          ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "星级"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.starType) + "\n          ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.row.address) + "\n          ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.row.phone) + "\n          ")])], 1)], 1), _vm._v(" "), (!_vm.isSubmit) ? _c('el-divider', [_vm._v("运动员信息")]) : _vm._e(), _vm._v(" "), (!_vm.isSubmit) ? _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm mt10",
    attrs: {
      "model": _vm.formData,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name",
      "rules": [{
        required: true,
        message: '姓名不能为空',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请填入报名人员姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.formData.numtype == 1) ? _c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "num",
      "rules": [{
        required: true,
        validator: _vm.validator.idCard,
        message: '请输入正确的身份证号',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1) : _c('el-form-item', {
    attrs: {
      "label": "护照号",
      "prop": "num",
      "rules": [{
        required: true,
        message: '护照号不能为空',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入护照号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证件类型",
      "prop": "numTypeName"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.numtype),
      callback: function($$v) {
        _vm.$set(_vm.formData, "numtype", $$v)
      },
      expression: "formData.numtype"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("身份证")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("护照")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("满14周岁以上不可参与考级")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm2('ruleForm2')
      }
    }
  }, [_vm._v("下一步\n            ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isSubmit) ? _c('el-divider', [_vm._v("运动员信息确认")]) : _vm._e(), _vm._v(" "), (_vm.isSubmit) ? _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "140px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name",
      "rules": []
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "type": "text",
      "placeholder": "请填入报名人员姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc mt10"
  }, [_vm._v("此处填写运动员姓名后将不予修改，须返回上一步重新认证运动员")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证件号",
      "prop": "num",
      "rules": []
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "type": "text",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.formData.numtype != 1) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "生日",
      "prop": "birthday",
      "rules": [{
        required: true,
        message: '请选择生日'
      } ]
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "type": "date",
      "picker-options": {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      "placeholder": "请选择生日"
    },
    model: {
      value: (_vm.formData.birthday),
      callback: function($$v) {
        _vm.$set(_vm.formData, "birthday", $$v)
      },
      expression: "formData.birthday"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否连考",
      "rules": []
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 2,
      "active-text": "是",
      "inactive-text": "否",
      "active-color": "#409EFF",
      "inactive-color": "#ddd"
    },
    on: {
      "change": _vm.onLiankaoChange
    },
    model: {
      value: (_vm.formData.is_exam_continue),
      callback: function($$v) {
        _vm.$set(_vm.formData, "is_exam_continue", $$v)
      },
      expression: "formData.is_exam_continue"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "sex"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.sex),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sex", $$v)
      },
      expression: "formData.sex"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("女")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "报考星级",
      "prop": "grade"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.grade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "grade", $$v)
      },
      expression: "formData.grade"
    }
  }, _vm._l((_vm.gradeSelectColumns), function(item) {
    return _c('el-radio', {
      key: item,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("黄星级及黄星级以上，须有近一年内CCA组织的赛事经历；")]), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("连考须达到连考条件")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "添加证件照片(2寸)",
      "prop": "pic"
    }
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pic,
      "limit": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc"
  }, [_vm._v("上传2寸免冠照,此照片用于证书粘贴打印")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "衣服尺码",
      "prop": "csize",
      "rules": _vm.formData.grade.indexOf('红') != -1 ? [{
        required: true,
        message: '请输入尺码',
        trigger: 'blur'
      } ] : []
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入尺码"
    },
    model: {
      value: (_vm.formData.csize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "csize", $$v)
      },
      expression: "formData.csize"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc mt10 cp",
    on: {
      "click": function($event) {
        _vm.cSizeShow = true
      }
    }
  }, [_vm._v("查看衣服尺码表")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "鞋  码",
      "prop": "footsize",
      "rules": _vm.formData.grade.indexOf('红') != -1 ? [{
        required: true,
        message: '请输入鞋码',
        trigger: 'blur'
      } ] : []
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入鞋码"
    },
    model: {
      value: (_vm.formData.footsize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "footsize", $$v)
      },
      expression: "formData.footsize"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-label-desc mt10 cp",
    on: {
      "click": function($event) {
        _vm.fSizeShow = true
      }
    }
  }, [_vm._v("查看鞋码表")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("下一步\n            ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "信息核对",
      "show-cancel-button": ""
    },
    on: {
      "confirm": function($event) {
        return _vm.onConfirmSubmit()
      }
    },
    model: {
      value: (_vm.confirmShow),
      callback: function($$v) {
        _vm.confirmShow = $$v
      },
      expression: "confirmShow"
    }
  }, [_c('van-cell-group', {
    staticStyle: {
      "height": "8rem",
      "overflow-y": "scroll"
    }
  }, [_c('van-field', {
    attrs: {
      "readonly": "",
      "label": "姓名",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "证件号",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "报考星级",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.grade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "grade", $$v)
      },
      expression: "formData.grade"
    }
  }), _vm._v(" "), (_vm.formData.pic.length > 0) ? _c('van-cell', {
    attrs: {
      "title": "证件照片(2寸)"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.formData.pic[0].url,
      "width": "100"
    }
  })]) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "衣服尺码",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.csize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "csize", $$v)
      },
      expression: "formData.csize"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "鞋  码",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.footsize),
      callback: function($$v) {
        _vm.$set(_vm.formData, "footsize", $$v)
      },
      expression: "formData.footsize"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "家长姓名",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.famliy_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "famliy_name", $$v)
      },
      expression: "formData.famliy_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "身份证号码",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.famliy_num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "famliy_num", $$v)
      },
      expression: "formData.famliy_num"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "联系方式",
      "input-align": "right"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.cSizeShow,
      "title": "衣服尺码表"
    },
    on: {
      "update:visible": function($event) {
        _vm.cSizeShow = $event
      }
    }
  }, _vm._l((_vm.cSizePicList), function(pic, key) {
    return _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": pic
      },
      on: {
        "click": function($event) {
          return _vm.picShow(key, _vm.cSizePicList)
        }
      }
    })
  }), 0), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.fSizeShow,
      "title": "鞋码表"
    },
    on: {
      "update:visible": function($event) {
        _vm.fSizeShow = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "padding": "10px",
      "text-align": "center"
    }
  }, [_vm._v("此鞋型偏小，建议选大一码")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.fSizePicList[0]
    },
    on: {
      "click": function($event) {
        return _vm.picShow(0, _vm.fSizePicList)
      }
    }
  })]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df9a71c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameApplyMemberAdd.vue
// module id = 1563
// module chunks = 0